import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../_common/Form/Buttons/Button';
import classes from './statusForm.module.scss';
import InputField from '../../../../_common/Form/TextFields/InputField';
import Select from '../../../../_common/Form/Selects/Select/Select';
import utils from '../../../../../utils/utils';

const copayNetworkOptions = [
  'Cancer Care Foundation',
  'Chronic Disease Fund',
  'Health Well',
  'LLS',
  'Patient Access Network',
  'Patient Advocate',
  'Patient Service Inc',
  'Safety Net Foundation',
  'Good Days',
  'Coupon',
  'Voucher',
  'Copay Card',
  'Other',
];

const CopayAssistanceStatus = ({ changeStatus, info }) => {
  const [formData, setFormData] = useState({});

  const { copayNetwork, networkPay, patientPay } = formData;

  useEffect(() => {
    setFormData({
      copayNetwork: info.copayNetwork || '',
      networkPay: info.networkPay || '',
      patientPay: info.patientPay || '',
    });
  }, []);

  const setStatus = (status) => {
    const data = { status, ...formData, copayApproval: 'Approved' };

    changeStatus(data);
  };

  return (
    <div className={classes.status_wrapper}>
      <p>Process the copay assistance and update the fields below.</p>

      <div className={classes.form}>
        <div style={{ margin: '7px auto ', width: 400 }}>
          <Select
            labelBG="#f6f8fa"
            label="Copay Network"
            options={copayNetworkOptions}
            onChange={(option) => setFormData((prev) => ({ ...prev, copayNetwork: option }))}
            currentOption={copayNetwork}
          />

          <InputField
            labelBG="#f6f8fa"
            label="Network Pay"
            value={networkPay}
            onChange={(value) => setFormData((prev) => ({ ...prev, networkPay: value }))}
            onKeyPress={(e) => utils.keyPressCurrency(e, false)}
            onPaste={(e) => utils.keyPressCurrency(e, true)}
          />

          <InputField
            labelBG="#f6f8fa"
            label="Patient Pay"
            value={patientPay}
            onChange={(value) => setFormData((prev) => ({ ...prev, patientPay: value }))}
            onKeyPress={(e) => utils.keyPressCurrency(e, false)}
            onPaste={(e) => utils.keyPressCurrency(e, true)}
          />

          <div className={classes.btns_wrapper}>
            <Button
              className={classes.max_content}
              title="Approved"
              approveButton
              onClick={() => setStatus('Schedule')}
            />

            <Button
              className={classes.max_content}
              title="Denied"
              deniedButton
              onClick={() => setStatus('Process')}
            />

            <Button
              className={classes.max_content}
              title="Flag for review"
              reviewButton
              onClick={() => setStatus('Review')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

CopayAssistanceStatus.propTypes = {
  info: PropTypes.object.isRequired,
  changeStatus: PropTypes.func.isRequired,
};

export default CopayAssistanceStatus;
